export default __webpack_public_path__ + "static/media/icon_shopify.530266f5.png";